import { render } from "./App.vue?vue&type=template&id=5cba0f50"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5cba0f50&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\Dont Get Got\\dont-get-got\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__